module.exports = __webpack_public_path__ + "static/media/nam_thumb.2b32b249.webp";